export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW';

export const RELOAD_INSIGHTS_GRID_DATA = 'RELOAD_INSIGHTS_GRID_DATA';
export const RELOAD_CALL_LOGS_GRID_DATA = 'RELOAD_CALL_LOGS_GRID_DATA';

export const SET_INSIGHT_REPORT_TYPE = 'SET_INSIGHT_REPORT_TYPE';
export const SET_CALLLOG_REPORT_TYPE = 'SET_CALLLOG_REPORT_TYPE';

export const SET_INSIGHTS_COL_DEFS = 'SET_INSIGHTS_COL_DEFS';
export const SET_INSIGHTS_COL_DEFS_LOADED_FROM_API = 'SET_INSIGHTS_COL_DEFS_LOADED_FROM_API';
export const SET_INSIGHTS_TAGS = 'SET_INSIGHTS_TAGS';

export const CLEAR_ACTIVE_INSIGHT_EXPANDED_GROUP_IDS = 'CLEAR_ACTIVE_INSIGHT_EXPANDED_GROUP_IDS';

export const SET_DEFAULT_INSIGHT_ACTIVE = 'SET_DEFAULT_INSIGHT_ACTIVE';
export const SET_DEFAULT_CALLLOG_ACTIVE = 'SET_DEFAULT_CALLLOG_ACTIVE';
export const SET_ACTIVE_INSIGHT = 'SET_ACTIVE_INSIGHT';
export const SET_ACTIVE_CALLLOG = 'SET_ACTIVE_CALLLOG';

export const SET_SAVED_INSIGHTS = 'SET_SAVED_INSIGHTS';
export const SET_SAVED_INSIGHT = 'SET_SAVED_INSIGHT';
export const DUPLICATE_SAVED_INSIGHT = 'DUPLICATE_SAVED_INSIGHT';
export const DELETE_SAVED_INSIGHT = 'DELETE_SAVED_INSIGHT';
export const SET_INSIGHT_LAST_UPDATED_AT = 'SET_INSIGHT_LAST_UPDATED_AT';
export const SET_CALL_LOG_LAST_UPDATED_AT = 'SET_CALL_LOG_LAST_UPDATED_AT';

export const SET_SELECTED_GROUP_BY = 'SET_SELECTED_GROUP_BY';
export const SET_GROUP_BY_INSIGHT_SETTINGS = 'SET_GROUP_BY_INSIGHT_SETTINGS';
export const SET_GROUP_BY_INSIGHT_DATA = 'SET_GROUP_BY_INSIGHT_DATA';

export const SET_INSIGHT_NAME = 'SET_INSIGHT_NAME';
export const SET_INSIGHT_FILTER_CRITERIA = 'SET_INSIGHT_FILTER_CRITERIA';
export const SET_INSIGHT_DATE_RANGE = 'SET_INSIGHT_DATE_RANGE';
export const SET_INSIGHT_AUTO_RELOAD = 'SET_INSIGHT_AUTO_RELOAD';
export const SET_INSIGHT_SAVED_VISIBILITY = 'SET_INSIGHT_SAVED_VISIBILITY';
export const SET_CALLLOG_NAME = 'SET_CALLLOG_NAME';
export const SET_CALLLOG_FILTER_CRITERIA = 'SET_CALLLOG_FILTER_CRITERIA';
export const SET_CALLLOG_DATE_RANGE = 'SET_CALLLOG_DATE_RANGE';
export const SET_CALLLOG_AUTO_RELOAD = 'SET_CALLLOG_AUTO_RELOAD';
export const SET_CALLLOG_GRID_STATE = 'SET_CALLLOG_GRID_STATE';
export const SET_CALLLOG_SAVED_VISIBILITY = 'SET_CALLLOG_SAVED_VISIBILITY';
  
export const SET_INSIGHT_SELECTED_CHART_TYPE = 'SET_INSIGHT_SELECTED_CHART_TYPE';
export const PREPEND_AND_FILTER_CRITERIA = 'PREPEND_AND_FILTER_CRITERIA';
export const PREPEND_AND_FILTER_CRITERIA_TO_CALL_LOG = 'PREPEND_AND_FILTER_CRITERIA_TO_CALL_LOG';

export const SET_INSIGHT_GRID_STATE = 'SET_INSIGHT_GRID_STATE';
export const UPDATE_GRID_ROW_GROUPS = 'UPDATE_GRID_ROW_GROUPS';
export const DELETE_GRID_ROW_GROUP = 'DELETE_GRID_ROW_GROUP';
export const SET_GRID_ROW_GROUPS = 'SET_GRID_ROW_GROUPS';

export const RESET_INSIGHT_SETTINGS = 'RESET_INSIGHT_SETTINGS';

export const SET_CHART_DATA = 'SET_CHART_DATA';
export const SET_CHART_ALL_PARAMETERS = 'SET_CHART_ALL_PARAMETERS';
export const SET_CHART_SELECTED_PARAMETERS = 'SET_CHART_SELECTED_PARAMETERS';
export const SET_CHART_DRILLDOWN_STATE = 'SET_CHART_DRILLDOWN_STATE';
export const SET_CHART_LOADER_STATUS = 'SET_CHART_LOADER_STATUS';
export const SET_CHART_DRILLDOWN_DATA = 'SET_CHART_DRILLDOWN_DATA';

export const SET_EXPORT_FOR_AG_GRID = 'SET_EXPORT_FOR_AG_GRID';

export const SET_INSIGHT_TIMEZONE_ID = 'SET_INSIGHT_TIMEZONE_ID';
export const SET_CALLLOG_TIMEZONE_ID = 'SET_CALLLOG_TIMEZONE_ID';

export const SET_CALLLOG_HISTOGRAM_DATA = 'SET_CALLLOG_HISTOGRAM_DATA';
export const SET_CALLLOG_HISTOGRAM_LOADER_STATUS = 'SET_CALLLOG_HISTOGRAM_LOADER_STATUS';
export const SET_CALLLOG_HISTOGRAM_GROUPING = 'SET_CALLLOG_HISTOGRAM_GROUPING';

export const SET_CALLLOG_QUICK_INSIGHTS_TAB = 'SET_CALLLOG_QUICK_INSIGHTS_TAB';
export const SET_CALLLOG_QUICK_INSIGHTS_COLUMN_STATE = 'SET_CALLLOG_QUICK_INSIGHTS_COLUMN_STATE';

export const SET_INSIGHTS_DATA_CACHE = 'SET_INSIGHTS_DATA_CACHE';
export const CLEAR_INSIGHTS_DATA_CACHE = 'CLEAR_INSIGHTS_DATA_CACHE';
export const SET_CALL_LOGS_DATA = 'SET_CALL_LOGS_DATA';
export const SET_CALL_LOGS_COL_DEFS = 'SET_CALL_LOGS_COL_DEFS';
export const SET_CALL_LOGS_COL_DEFS_LOADED_FROM_API = 'SET_CALL_LOGS_COL_DEFS_LOADED_FROM_API';
export const APPEND_TO_CALL_LOGS_DATA = 'APPEND_TO_CALL_LOGS_DATA';
export const RESET_CALL_LOG_DETAILS = 'RESET_CALL_LOG_DETAILS';
export const SET_CALL_LOG_DETAILS = 'SET_CALL_LOG_DETAILS';
export const SET_CALL_LOGS_QUICK_INSIGHTS_DATA_CACHE = 'SET_CALL_LOGS_QUICK_INSIGHTS_DATA_CACHE';
export const SET_CALL_LOGS_HISTOGRAM_DATA_CACHE = 'SET_CALL_LOGS_HISTOGRAM_DATA_CACHE';

export const SET_CALL_LOGS_VISIBILITY_SECTION = 'SET_CALL_LOGS_VISIBILITY_SECTION';

export const SET_TAG_AUTOCOMPLETE_VALUES = 'SET_TAG_AUTOCOMPLETE_VALUES';
export const APPEND_TAG_AUTOCOMPLETE_VALUES = 'APPEND_TAG_AUTOCOMPLETE_VALUES';
export const SET_CALL_FIELD_AUTOCOMPLETE_VALUES = 'SET_CALL_FIELD_AUTOCOMPLETE_VALUES';
export const APPEND_CALL_FIELD_AUTOCOMPLETE_VALUES = 'APPEND_CALL_FIELD_AUTOCOMPLETE_VALUES';
export const RESET_TAG_AUTOCOMPLETE_VALUES = 'RESET_TAG_AUTOCOMPLETE_VALUES';
export const RESET_CALL_FIELD_AUTOCOMPLETE_VALUES = 'RESET_CALL_FIELD_AUTOCOMPLETE_VALUES';

export const SET_CALL_LOGS_VIEW_AS = 'SET_CALL_LOGS_VIEW_AS';
export const SET_CALL_LOG_EXPORT_LOADER_VISIBILITY = 'SET_CALL_LOG_EXPORT_LOADER_VISIBILITY';